// Packages
import React from 'react';
import Skeleton from 'react-loading-skeleton';
// Configuration
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
// Services
import { apiFetchData } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import disableElementService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/disableElementService';
// Components
import BreadCrumbs from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/breadcrumbs';
import BlogSuggestions from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/blogSuggestions';
import MainTitle from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/mainTitle';
import AxiosError from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/axiosError';

export default class BlogContent extends React.Component {
    constructor(props) {
        super(props);
        this.pathExtension = pageConfig.blogPage.initialPathExtension;
        this.state = {
            publicResources: props.temporaryPublicResourcesSSR || props.publicResourcesSSR || null,
            errorMsg: null,
            isLoading: false,
            blogs: props.temporaryPublicResourcesSSR?.blogItems || props.publicResourcesSSR?.blogItems || [],
            page: pageConfig.blogPage.parametersForInitialRequest.page,
            limit: pageConfig.blogPage.parametersForInitialRequest.limit,
        };
        this.getData = this.getData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLoadMore = this.handleLoadMore.bind(this);
    }

    componentDidMount() {
        const { publicResources } = this.state;
        if (!publicResources) {
            this.getData();
        }
        disableElementService.removeServerSideRenderClass();
        window.isReactLoaded = true;
    }

    handleInputChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleLoadMore() {
        this.setState((prevState) => ({
            page: prevState.page + 1,
        }), () => {
            this.getData();
        });
    }

    getData() {
        const params = new URLSearchParams(window.location.search);
        const category = params.get('category') ? encodeURIComponent(params.get('category')) : 0;
        const tag = params.get('tag') ? encodeURIComponent(params.get('tag')) : 0;
        const keywords = params.get('keywords') ? encodeURIComponent(params.get('keywords')) : 0;
        const stateData = this.state;
        this.setState({ isLoading: true });
        apiFetchData(this.pathExtension, `/${stateData.page}/${stateData.limit}/${category}/${tag}/${keywords}`)
            .then((res) => {
                if (res.status === 200) {
                    this.setState((prevState) => ({
                        blogs: [...prevState.blogs, ...res.data.blogItems],
                        publicResources: res.data,
                    }));
                    return;
                }
                reportError(res);
            })
            .catch((err) => {
                this.setState({
                    errorMsg: err,
                });
                reportError(err);
            })
            .finally(() => {
                this.setState({
                    isLoading: false,
                });
            });
    }

    blogItemSkeleton = (index) => (
        <div className="blog__item" key={index}>
            <div className="blog__item__left">
                <Skeleton width="100%" />
            </div>
            <div className="blog__item__right">
                <h4>
                    <Skeleton width="50%" height={20} />
                </h4>
                <p>
                    <Skeleton count={6} />
                </p>
            </div>
        </div>
    );

    render() {
        const { isLoading, errorMsg, publicResources, page, limit, blogs } = this.state;

        return (
            <>
                <BreadCrumbs breadcrumbs={publicResources?.breadcrumbs} breadcrumbsStructuredData={publicResources?.breadcrumbsStructuredData} isLoading={isLoading} skeletonMaxWidthPx={115} />
                {isLoading && (
                    <>
                        <div>
                            <div className="row pageContent">
                                <div className="col-12">
                                    <Skeleton width="20%" height={30} />
                                </div>
                                <div className="col-md-12 aboutUsText">
                                    <Skeleton width="30%" height={25} className="mb-3 d-block" />
                                    <Skeleton width="70%" height={20} className="mb-3 d-block" />
                                    {new Array(10).fill(null).map((item, index) => this.blogItemSkeleton(index))}
                                    <div className="d-flex justify-content-center">
                                        <Skeleton width={200} height={48} className="loadMoreBtn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {errorMsg && <AxiosError />}
                {publicResources && (
                    <div>
                        <div className="row pageContent">
                            {publicResources.mainTitle && (
                                <div className="col-12">
                                    <MainTitle title={publicResources.mainTitle} />
                                </div>
                            )}
                            <div className="col-md-12 aboutUsText">
                                <h3 className="mt-0 blog__intro-title">{publicResources.introTextTitle}</h3>
                                <p className="blog__intro-text">{publicResources.introText}</p>
                                {publicResources.totalBlogItemsCount > 0 ? (
                                    <>
                                        {blogs.map((item, index) => (
                                            <a href={item.readMoreURL} key={index}>
                                                <div className="blog__item">
                                                    <div className="blog__item__left">
                                                        <img
                                                            loading="lazy"
                                                            className="blog__item__img"
                                                            src={item.image.sourceURL}
                                                            srcSet={[
                                                                `${item.image.sourceURL} 1x`,
                                                                item.imageSourceURLLargeSizeAlternative ? `${item.imageSourceURLLargeSizeAlternative} 2x` : '',
                                                                item.imageSourceURLLargeSizeAlternative ? `${item.imageSourceURLLargeSizeAlternative} 3x` : '',
                                                            ]
                                                                .filter(Boolean)
                                                                .join(', ')}
                                                            alt={item.image.altText}
                                                            title={item.image.titleText}
                                                            width={286}
                                                            height={190}
                                                            style={{ aspectRatio: `${286} / ${190}` }}
                                                        />
                                                        <span className="blog__item__publish-date">{item.publishDate}</span>
                                                    </div>
                                                    <div className="blog__item__right">
                                                        <h4 className="blog__item__title">{item.title}</h4>
                                                        <p className="blog__item__description">{item.description}</p>
                                                        <span className="blog__read-more-text">{item.readMoreTitle}</span>
                                                    </div>
                                                </div>
                                            </a>
                                        ))}
                                        <button
                                            className="form__button form__button--primary loadMoreBtn"
                                            type="button"
                                            onClick={this.handleLoadMore}
                                            disabled={page * limit >= publicResources.totalBlogItemsCount === true}
                                        >
                                            {publicResources.loadMoreText}
                                        </button>
                                    </>
                                ) : (
                                    <BlogSuggestions category="0" />
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}
